import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { useAuth } from '../../context/auth'
import useSubAccountDetails from '../../hooks/useSubAccountDetails.ts'
import { isUserExistsInGroup } from '../../utils/userRights.ts'
import CheckStripeRequirements from './CheckStripeRequirements.tsx'
import DisplayMessage from './DisplayMessage.tsx'

const TopMessageBox = () => {
  const { state } = useAuth()
  const { subAccount, loading, refetch } = useSubAccountDetails()
  const { pathname } = useLocation()
  const isOnCorrectPage = pathname.includes('/payments/stripe-account')
  const [isRequirementFilled, setIsRequirementFilled] = useState(true)
  const isRestricted = subAccount?.user_groups
    ? subAccount.user_groups.includes('dd_panel_restricted_users')
    : undefined
  const isCertificateRequiredUser = isUserExistsInGroup(
    state.groups,
    'certificate_required_users_group_name'
  )
  const [userGroups, setUserGroups] = useState<string[] | undefined>(undefined)

  useEffect(() => {
    if (subAccount?.user_groups) {
      setUserGroups(subAccount.user_groups)
    }
    if (subAccount?.user_groups && userGroups !== subAccount.user_groups) {
      setTimeout(() => {
        refetch()
      }, 3000)
    }
  }, [state.groups])

  if (isRestricted || isRestricted === undefined) return null

  return (
    <>
      {!loading &&
        !subAccount?.onboarding_completed &&
        !isOnCorrectPage &&
        !isCertificateRequiredUser && (
          <DisplayMessage
            message={
              'Brak konta Stripe do zarządzania płatnościami lub jest ono nieaktywne'
            }
            navigateUrl={'/payments/stripe-account'}
            navigateLabel={' Przejdź do sekcji Konto Stripe'}
          />
        )}

      {isCertificateRequiredUser && (
        <DisplayMessage
          message={
            'Nie potwierdzono uzyskania certyfikatu ze szkolenia dietetycznego dla kosmetologów, który jest wymagany do korzystania z panelu.'
          }
          navigateUrl={'https://dietokosmetologia.pl/'}
          navigateLabel={'Przejdź do strony i zapisz się na szkolenie.'}
        />
      )}

      {!loading && subAccount?.onboarding_completed && (
        <CheckStripeRequirements
          setIsRequirementFilled={setIsRequirementFilled}
        />
      )}
      {!loading &&
        subAccount?.onboarding_completed &&
        !isOnCorrectPage &&
        !isRequirementFilled && (
          <DisplayMessage
            message={'Wymagana weryfikacja tożsamości na koncie Stripe'}
            navigateUrl={'/payments/stripe-account'}
            navigateLabel={' Przejdź do sekcji Konto Stripe'}
          />
        )}
    </>
  )
}

export default TopMessageBox
